import { defineStore } from 'pinia'
import { type Ref, ref } from 'vue'
import {
  fetchMotorContractByPolicyId,
  fetchMotorQuoteByQuoteId
} from '@/stores/motorService'
import type { MotorContract } from '@/types/motor/MotorContract'
import type { EMobilContract } from '@/types/emobil/EMobilContract'

export const useMotorStore = defineStore('motor', () => {
  // only store internal values
  const contractsByPolicyId: Ref<Map<string, MotorContract | EMobilContract>> = ref(
    new Map<string, MotorContract>()
  )
  const motorQuotesByQuoteId: Ref<Map<string, MotorContract>> = ref(
    new Map<string, MotorContract>()
  )

  async function getMotorContractByPolicyId(
    policyId: string
  ): Promise<MotorContract | EMobilContract | null> {
    let contract = contractsByPolicyId.value.get(policyId) ?? null
    if (!contract) {
      contract = await fetchMotorContractByPolicyId(policyId)
      if (!contract) return null
      contractsByPolicyId.value.set(policyId, contract)
    }
    return contract
  }

  async function getMotorQuoteByQuoteId(quoteId: string): Promise<MotorContract | null> {
    let motorQuote = motorQuotesByQuoteId.value.get(quoteId) ?? null
    if (!motorQuote) {
      motorQuote = await fetchMotorQuoteByQuoteId(quoteId)
      if (!motorQuote) return null
      motorQuotesByQuoteId.value.set(quoteId, motorQuote)
    }
    return motorQuote
  }

  return {
    getMotorContractByPolicyId,
    getMotorQuoteByQuoteId
  }
})
